<template>
    <form @submit.prevent="emitSubmit">
        <div class="row">
            <div class="small-12 columns" :class="{ error: showPwnedAccountErrorText }">
                <label>
                    {{ pwnedAccountTypeString }}, die geprüft werden soll
                    <div class="hint-text">
                        {{ pwnedAccountHelpString }}
                    </div>
                    <input type="text" v-model="caseData.pwned_account" :readonly="showExtendedInput"/>
                </label>
                <small class="error" v-if="showPwnedAccountErrorText">
                    {{ pwnedAccountErrorText }}
                </small>
            </div>
            <template v-if="showExtendedInput">
                <div class="small-12 columns">
                    <div class="panel radius">
                        <h6 class="orange-colored-text">ACHTUNG</h6>
                        <p>
                            Die von Ihnen eingegebene {{ pwnedAccountTypeString }} ist vom Facebook-Datenskandal betroffen. Sie haben
                            deshalb Aussicht auf mindestens 500,00 € Schadensersatz!
                        </p>
                        <p>
                            Diesen Schadensersatzanspruch können Sie mithilfe unseres Online-Tools mit ein paar weiteren
                            Eingaben gleich selbst gegenüber Facebook bzw. Meta einfordern. Das Tool versendet in Ihrem
                            Namen eine E-Mail, mit der Meta u.a. angeboten wird, den Schaden durch eine schnelle Zahlung
                            binnen 2 Wochen in Höhe von 500,00 € ohne Einschaltung der Gerichte auszugleichen. Sollte
                            Meta nicht fristgemäß reagieren, haben Sie dann auch die Möglichkeit einen höheren Schadensersatz
                            gerichtlich einzufordern. Ob Ihnen überhaupt und in welcher Höhe ein Schadensersatz gerichtlich
                            zugesprochen wird, ist allerdings noch nicht abschließend geklärt.
                        </p>
                    </div>
                </div>
                <div class="small-12 columns" :class="{ error: showMandatorLawformErrorText }">
                    <label>
                        Anrede
                        <select v-model="mandator.lawform">
                            <option
                                v-for="lawform in lawformSelectData"
                                :key="lawform.value"
                                :value="lawform.value"
                            >
                                {{lawform.text}}
                            </option>
                        </select>
                    </label>
                    <small class="error" v-if="showMandatorLawformErrorText">
                        {{ mandatorLawformErrorText }}
                    </small>
                </div>
                <div class="small-12 columns" :class="{ error: showMandatorPrenameErrorText }">
                    <label>
                        Vorname
                        <input type="text" v-model="mandator.prename"/>
                    </label>
                    <small class="error" v-if="showMandatorPrenameErrorText">
                        {{ mandatorPrenameErrorText }}
                    </small>
                </div>
                <div class="small-12 columns" :class="{ error: showMandatorSurnameErrorText }">
                    <label>
                        Nachname
                        <input type="text" v-model="mandator.surname"/>
                    </label>
                    <small class="error" v-if="showMandatorSurnameErrorText">
                        {{ mandatorSurnameErrorText }}
                    </small>
                </div>
                <div class="small-9 columns" :class="{ error: showMandatorStreetErrorText }">
                    <label>
                        Straße
                        <input type="text" v-model="mandator.street"/>
                    </label>
                    <small class="error" v-if="showMandatorStreetErrorText">
                        {{ mandatorStreetErrorText }}
                    </small>
                </div>
                <div class="small-3 columns" :class="{ error: showMandatorHouseNumberErrorText }">
                    <label>
                        Hausnummer
                        <input type="text" v-model="mandator.house_number"/>
                    </label>
                    <small class="error" v-if="showMandatorHouseNumberErrorText">
                        {{ mandatorHouseNumberErrorText }}
                    </small>
                </div>
                <div class="small-4 columns" :class="{ error: showMandatorZipErrorText }">
                    <label>
                        PLZ
                        <input type="text" v-model="mandator.zip"/>
                    </label>
                    <small class="error" v-if="showMandatorZipErrorText">
                        {{ mandatorZipErrorText }}
                    </small>
                </div>
                <div class="small-8 columns" :class="{ error: showMandatorCityErrorText }">
                    <label>
                        Ort
                        <input type="text" v-model="mandator.city"/>
                    </label>
                    <small class="error" v-if="showMandatorCityErrorText">
                        {{ mandatorCityErrorText }}
                    </small>
                </div>
                <div class="small-12 columns" :class="{ error: showMandatorMailErrorText }">
                    <label>
                        E-Mail Adresse (für die Korrespondenz mit Facebook)
                        <input type="text" v-model="mandator.mail"/>
                    </label>
                    <small class="error" v-if="showMandatorMailErrorText">
                        {{ mandatorMailErrorText }}
                    </small>
                </div>
                <div class="small-12 columns" :class="{ error: showMandatorIbanErrorText }">
                    <label>
                        IBAN (für die Entschädigungszahlung)
                        <input type="text" v-model="mandator.iban"/>
                    </label>
                    <small class="error" v-if="showMandatorIbanErrorText">
                        {{ mandatorIbanErrorText }}
                    </small>
                </div>
                <div class="small-12 columns" :class="{ error: showMandatorBicErrorText }">
                    <label>
                        BIC (für die Entschädigungszahlung)
                        <input type="text" v-model="mandator.bic"/>
                    </label>
                    <small class="error" v-if="showMandatorBicErrorText">
                        {{ mandatorBicErrorText }}
                    </small>
                </div>
                <div class="small-12 columns" :class="{ error: showFbProfileLinkErrorText }">
                    <label>
                        Ihr Facebook Profillink
                        <input type="text" v-model="caseData.fb_profile_link"/>
                    </label>
                    <small class="error" v-if="showFbProfileLinkErrorText">
                        {{ fbProfileLinkErrorText }}
                    </small>
                    <div class="panel radius">
                        <h6 class="bold-text">Wo finde ich meinen Facebook Profillink?</h6>
                        <p>
                            Klicken Sie <a href="https://www.facebook.com/profile.php" target="_blank" class="bold-text">hier</a>
                            um zu Facebook zu gelangen und melden Sie sich, falls nötig, mit Ihrem Konto an. In der
                            Adressleiste Ihres Browsers wird anschließend Ihr Profillink angezeigt.
                            Dieser sieht ungefähr so aus: https://www.facebook.com/max.mustermann
                        </p>
                    </div>
                </div>
            </template>
            <template v-else>
                <div class="small-12 columns">
                    <div class="panel radius">
                        <h6 class="orange-colored-text">ACHTUNG</h6>
                        <p>
                            Bitte verwenden Sie nur eine {{pwnedAccountTypeString}} die auch mit Ihrem Facebookkonto verknüpft ist.
                        </p>
                        <p>
                            Um die mit Ihrem Konto verknüpften {{pwnedAccountTypeString}}n einzusehen, klicken Sie
                            <a href="https://www.facebook.com/settings?tab=account" target="_blank" class="bold-text">hier</a>
                            um zu Facebook zu gelangen und melden Sie sich, falls nötig, mit Ihrem Konto an. Klicken Sie
                            dann im Bereich <span class="bold-text">Kontakt</span> auf <span class="bold-text">Bearbeiten</span>
                            um alle mit Ihrem Konto verknüpften {{pwnedAccountTypeString}}n einzusehen.
                        </p>
                    </div>
                </div>
            </template>
        </div>
    </form>
</template>

<script>
import Lawforms from '../constants/Lawforms';
import TypeHelper from '../helper/TypeHelper';
import Validation from '../helper/Validation';
import Modes from '../constants/Modes';

export default {
    name: 'PwnedForm',
    props: {
        showExtendedInput: Boolean,
        mode: Number
    },
    data: () => ({
        caseData: {
            pwned_account:      null,
            fb_profile_link:    null,
        },
        mandator: {
            lawform:        null,
            prename:        null,
            surname:        null,
            street:         null,
            house_number:   null,
            zip:            null,
            city:           null,
            iban:           null,
            bic:            null,
            mail:           null
        },
        validation: {
            isFormDirty:            false,
            isPwnedAccountDirty:    false,
            isMandatorLawformDirty: false,
            isMandatorPrenameDirty: false,
            isMandatorSurnameDirty: false,
            isMandatorIbanDirty:    false,
            isMandatorMailDirty:    false,
            isFbProfileLinkDirty:   false,
            isMandatorStreetDirty: false,
            isMandatorHouseNumberDirty: false,
            isMandatorZipDirty: false,
            isMandatorCityDirty: false,
            isMandatorBicDirty: false
        },
        lawformSelectData: [
            Lawforms.HERR,
            Lawforms.FRAU
        ],
    }),
    computed: {
        showPwnedAccountErrorText()
        {
            return (this.validation.isFormDirty || this.validation.isPwnedAccountDirty)
                && TypeHelper.isNotNullOrUndefined(this.pwnedAccountErrorText);
        },
        showMandatorLawformErrorText()
        {
            return (this.validation.isFormDirty || this.validation.isMandatorLawformDirty)
                && TypeHelper.isNotNullOrUndefined(this.mandatorLawformErrorText);
        },
        showMandatorPrenameErrorText()
        {
            return (this.validation.isFormDirty || this.validation.isMandatorPrenameDirty)
                && TypeHelper.isNotNullOrUndefined(this.mandatorPrenameErrorText);
        },
        showMandatorSurnameErrorText()
        {
            return (this.validation.isFormDirty || this.validation.isMandatorSurnameDirty)
                && TypeHelper.isNotNullOrUndefined(this.mandatorSurnameErrorText);
        },
        showMandatorIbanErrorText()
        {
            return (this.validation.isFormDirty || this.validation.isMandatorIbanDirty)
                && TypeHelper.isNotNullOrUndefined(this.mandatorIbanErrorText);
        },
        showMandatorMailErrorText()
        {
            return (this.validation.isFormDirty || this.validation.isMandatorMailDirty)
                && TypeHelper.isNotNullOrUndefined(this.mandatorMailErrorText);
        },
        showMandatorStreetErrorText()
        {
            return (this.validation.isFormDirty || this.validation.isMandatorStreetDirty)
                && TypeHelper.isNotNullOrUndefined(this.mandatorStreetErrorText);
        },
        showMandatorHouseNumberErrorText()
        {
            return (this.validation.isFormDirty || this.validation.isMandatorHouseNumberDirty)
                && TypeHelper.isNotNullOrUndefined(this.mandatorHouseNumberErrorText);
        },
        showMandatorZipErrorText()
        {
            return (this.validation.isFormDirty || this.validation.isMandatorZipDirty)
                && TypeHelper.isNotNullOrUndefined(this.mandatorZipErrorText);
        },
        showMandatorCityErrorText()
        {
            return (this.validation.isFormDirty || this.validation.isMandatorCityDirty)
                && TypeHelper.isNotNullOrUndefined(this.mandatorCityErrorText);
        },
        showMandatorBicErrorText()
        {
            return (this.validation.isFormDirty || this.validation.isMandatorBicDirty)
                && TypeHelper.isNotNullOrUndefined(this.mandatorBicErrorText);
        },
        showFbProfileLinkErrorText()
        {
            return (this.validation.isFormDirty || this.validation.isFbProfileLinkDirty)
                && TypeHelper.isNotNullOrUndefined(this.fbProfileLinkErrorText);
        },
        pwnedAccountErrorText()
        {
            let validators = [
                Validation.isNotNull
            ];

            if (this.isPhoneNumber)
                validators.push(Validation.isInternationalPhone);
            else
                validators.push(Validation.isEmail);

            return Validation.runValidation(this.caseData.pwned_account, validators);
        },
        mandatorLawformErrorText()
        {
            let validators = [
                Validation.requiresSelect
            ];

            return Validation.runValidation(this.mandator.lawform, validators);
        },
        mandatorPrenameErrorText()
        {
            let validators = [
                Validation.isNotNull
            ];

            return Validation.runValidation(this.mandator.prename, validators);
        },
        mandatorSurnameErrorText()
        {
            let validators = [
                Validation.isNotNull
            ];

            return Validation.runValidation(this.mandator.surname, validators);
        },
        mandatorIbanErrorText()
        {
            let validators = [
                Validation.isNotNull,
                Validation.isIban
            ];

            return Validation.runValidation(this.mandator.iban, validators);
        },
        mandatorMailErrorText()
        {
            let validators = [
                Validation.isNotNull,
                Validation.isEmail
            ];

            return Validation.runValidation(this.mandator.mail, validators);
        },
        fbProfileLinkErrorText()
        {
            let validators = [
                Validation.isNotNull,
                Validation.isUrl
            ];

            return Validation.runValidation(this.caseData.fb_profile_link, validators);
        },
        mandatorStreetErrorText()
        {
            let validators = [
                Validation.isNotNull
            ];

            return Validation.runValidation(this.mandator.street, validators);
        },
        mandatorHouseNumberErrorText()
        {
            let validators = [
                Validation.isNotNull
            ];

            return Validation.runValidation(this.mandator.house_number, validators);
        },
        mandatorZipErrorText()
        {
            let validators = [
                Validation.isNotNull,
                Validation.isNumeric,
                v => Validation.hasMinLength(v, 5)
            ];

            return Validation.runValidation(this.mandator.zip, validators);
        },
        mandatorCityErrorText()
        {
            let validators = [
                Validation.isNotNull
            ];

            return Validation.runValidation(this.mandator.city, validators);
        },
        mandatorBicErrorText()
        {
            let validators = [
                Validation.isNotNull,
                Validation.isBic
            ];
            
            return Validation.runValidation(this.mandator.bic, validators);
        },
        isPhoneNumber()
        {
            return this.mode === Modes.PHONE;
        },
        pwnedAccountTypeString()
        {
            if (this.isPhoneNumber)
                return 'Telefonnummer';

            return 'E-Mail Adresse';
        },
        pwnedAccountHelpString()
        {
            if (this.isPhoneNumber)
                return 'Telefonnummer im nationalen Format (ohne Leerzeichen und Ländervorwahl als 0) eingeben, Beispiel: 08519861300';
            else
                return 'Gültige E-Mail Adresse eingeben, Beispiel: maxmustermann@muster.de';
        }
    },
    methods: {
        validateForm()
        {
            if (this.showExtendedInput)
                this.validation.isFormDirty = true;
            else 
                this.validation.isPwnedAccountDirty = true;

            this.emitValidity();
        },
        emitValidity()
        {
            this.$emit('updateValidity', this.isFormValid());
        },
        emitSubmit()
        {
            this.$emit('submitForm');
        },
        isFormValid()
        {
            let isValid = true;
            isValid = isValid && (this.pwnedAccountErrorText === null);

            if (this.showExtendedInput)
            {
                isValid = isValid && (this.mandatorLawformErrorText === null);
                isValid = isValid && (this.mandatorPrenameErrorText === null);
                isValid = isValid && (this.mandatorSurnameErrorText === null);
                isValid = isValid && (this.mandatorIbanErrorText === null);
                isValid = isValid && (this.mandatorMailErrorText === null);
                isValid = isValid && (this.fbProfileLinkErrorText === null);
                isValid = isValid && (this.mandatorStreetErrorText === null);
                isValid = isValid && (this.mandatorHouseNumberErrorText === null);
                isValid = isValid && (this.mandatorZipErrorText === null);
                isValid = isValid && (this.mandatorCityErrorText === null);
                isValid = isValid && (this.mandatorBicErrorText === null);
            }

            return isValid;
        },
        emitChangedCaseData()
        {
            this.$emit('changeCaseData', this.caseData);
        },
        emitChangedMandatorData()
        {
            this.$emit('changeMandatorData', this.mandator);
        }
    },
    watch: {
        mode()
        {
            this.emitValidity();
        },
        showExtendedInput()
        {
            this.emitValidity();
        },
        'caseData.pwned_account': function()
        {
            this.validation.isPwnedAccountDirty = true;
        },
        'caseData.fb_profile_link': function()
        {
            this.validation.isFbProfileLinkDirty = true;
        },
        'mandator.lawform': function()
        {
            this.validation.isMandatorLawformDirty = true;
        },
        'mandator.prename': function()
        {
            this.validation.isMandatorPrenameDirty = true;
        },
        'mandator.surname': function()
        {
            this.validation.isMandatorSurnameDirty = true;
        },
        'mandator.iban': function()
        {
            this.validation.isMandatorIbanDirty = true;
        },
        'mandator.mail': function()
        {
            this.validation.isMandatorMailDirty = true;
        },
        'mandator.street': function()
        {
            this.validation.isMandatorStreetDirty = true;
        },
        'mandator.house_number': function()
        {
            this.validation.isMandatorHouseNumberDirty = true;
        },
        'mandator.zip': function()
        {
            this.validation.isMandatorZipDirty = true;
        },
        'mandator.city': function()
        {
            this.validation.isMandatorCityDirty = true;
        },
        'mandator.bic': function()
        {
            this.validation.isMandatorBicDirty = true;
        },
        caseData: {
            handler: function()
            {
                this.emitChangedCaseData();
                this.emitValidity();
            },
            deep: true
        },
        mandator: {
            handler: function()
            {
                this.emitChangedMandatorData();
                this.emitValidity();
            },
            deep: true
        }
    }
};
</script>

<style scoped>
.error label {
    color: #4d4d4d;
}
select {
    margin: 0 0 1rem;
}

.error select {
    margin-bottom: 0;
}

.orange-colored-text {
    color: orange;
}

.hint input {
    margin-bottom: 0;
}

.hint-text {
    color: grey;
    font-size: 0.75rem;
}

.bold-text {
    font-weight: bold;
}
</style>